import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4 gap-y-4" }
const _hoisted_2 = { class: "w-full bg-primary-color-50 text-primary-color-800 text-xs leading-4 font-semibold uppercase py-1 px-2 mb-2 rounded-md" }
const _hoisted_3 = ["onClick"]

import { ref } from "vue"
import { SearchIcon } from "@heroicons/vue/outline"
import GgmsInput from "@/components/GgmsInput.vue"
import TriggerNode from "@/components/workflows/TriggerNode.vue"
import MembershipChangedTriggerSidebar from "@/components/workflows/sidebar/trigger/MembershipChangedTriggerSidebar.vue"
import PropertyValueChangeTriggerSidebar from "@/components/workflows/sidebar/trigger/PropertyValueChangeTriggerSidebar.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import { ContactActivityTriggerNodeType, TriggerNodeType } from "@/shared/models/workflow"
import SubmissionAndViewSidebar from "./SubmissionAndViewSidebar.vue"
import EnrollAndUnenrollSidebar from "./EnrollAndUnenrollSidebar.vue"

interface Props {
    modelValue: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactActivityTriggerSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "changeAction"],
  setup(__props: any, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const searchTerm = ref()
const eventsCategories = [
    {
        title: "call",
        events: [ContactActivityTriggerNodeType.callStarted, ContactActivityTriggerNodeType.callEnded],
    },
    {
        title: "lead",
        events: [ContactActivityTriggerNodeType.propertyValueChanged, ContactActivityTriggerNodeType.leadCreated],
    },
    {
        title: "form",
        events: [ContactActivityTriggerNodeType.submission, ContactActivityTriggerNodeType.view],
    },
    { title: "list", events: [ContactActivityTriggerNodeType.membershipChanged] },
    {
        title: "workflow",
        events: [
            ContactActivityTriggerNodeType.enrolledInWorkflow,
            ContactActivityTriggerNodeType.unenrollFromWorkflow,
        ],
    },
]


const emit = __emit

function chooseEvent(event: string) {
    workflowStore.modelValue = event
    switch (event) {
        case ContactActivityTriggerNodeType.membershipChanged:
            emit("changeAction", { componentName: MembershipChangedTriggerSidebar.__name })
            break
        case ContactActivityTriggerNodeType.propertyValueChanged:
            emit("changeAction", { componentName: PropertyValueChangeTriggerSidebar.__name })
            break
        case ContactActivityTriggerNodeType.submission:
            workflowStore.isSubmission = true
            emit("changeAction", { componentName: SubmissionAndViewSidebar.__name })
            break
        case ContactActivityTriggerNodeType.view:
            workflowStore.isSubmission = false
            emit("changeAction", { componentName: SubmissionAndViewSidebar.__name })
            break
        case ContactActivityTriggerNodeType.enrolledInWorkflow:
            workflowStore.isEnrollWorkflow = true
            emit("changeAction", { componentName: EnrollAndUnenrollSidebar.__name })
            break
        case ContactActivityTriggerNodeType.unenrollFromWorkflow:
            workflowStore.isEnrollWorkflow = false
            emit("changeAction", { componentName: EnrollAndUnenrollSidebar.__name })
            break
        default:
            emit("changeAction", { componentName: TriggerNode.__name, node: TriggerNodeType.contactActivity })
            break
    }
    workflowStore.setHeaderText()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      "input-class": "bg-gray-100 border-0",
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      small: true,
      iconEnd: _unref(SearchIcon),
      placeholder: "Search"
    }, null, 8, ["modelValue", "iconEnd"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(eventsCategories, (category) => {
        return _createElementVNode("div", {
          key: category.title,
          class: "flex flex-col"
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(category.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.events, (event) => {
            return (_openBlock(), _createElementBlock("div", {
              key: event,
              class: "text-gray-900 text-base leading-6 font-medium p-2.5 cursor-pointer",
              onClick: ($event: any) => (chooseEvent(event))
            }, _toDisplayString(_unref(convertTriggerEvent)(event)), 9, _hoisted_3))
          }), 128))
        ])
      }), 64))
    ])
  ], 64))
}
}

})